"use client"

import { Navigate, Outlet, useLocation } from "react-router-dom"
import { useState, useEffect } from "react"
import { Spinner, Modal, ModalBody } from "reactstrap"
import AuthService from "../Service/AuthService"

const PrivateRoute = () => {
  const location = useLocation()
  const [authState, setAuthState] = useState<{
    isAuthenticated: boolean | null
    isLoading: boolean
    error: string | null
  }>({
    isAuthenticated: null,
    isLoading: true,
    error: null,
  })

  // ✅ NEW: Redirect state for professional loading
  const [redirectState, setRedirectState] = useState<{
    isRedirecting: boolean
    message: string
  }>({
    isRedirecting: false,
    message: "",
  })

  useEffect(() => {
    checkAuthentication()
  }, [location.pathname])

  const checkAuthentication = async () => {
    try {
  
      const token = AuthService.getToken()
    
      if (!token) {
       
        setAuthState({
          isAuthenticated: false,
          isLoading: false,
          error: null,
        })
        return
      }

      const isValid = AuthService.isTokenValid()
  
      if (!isValid) {
        
        AuthService.logout()
        setAuthState({
          isAuthenticated: false,
          isLoading: false,
          error: "Token expired",
        })
        return
      }

      const decoded = AuthService.getDecodedToken()
     
      if (!decoded || !decoded.user_id) {
        
        AuthService.logout()
        setAuthState({
          isAuthenticated: false,
          isLoading: false,
          error: "Invalid token",
        })
        return
      }

      
      setAuthState({
        isAuthenticated: true,
        isLoading: false,
        error: null,
      })
    } catch (error) {
      
      AuthService.logout()
      setAuthState({
        isAuthenticated: false,
        isLoading: false,
        error: "Authentication failed",
      })
    }
  }

  // ✅ NEW: Handle professional redirect with loading
  const handleRedirectToDashboard = (message: string) => {
    setRedirectState({
      isRedirecting: true,
      message,
    })

  
    setTimeout(() => {
      const dashboardPath = `${process.env.PUBLIC_URL || ""}/dashboard`
      window.location.href = dashboardPath // Use window.location for clean redirect
    }, 3000)
  }


  if (redirectState.isRedirecting) {
    return (
      <Modal isOpen={true} centered backdrop="static" keyboard={false}>
        <ModalBody className="text-center py-5">
          <div className="mb-4">
            <Spinner color="success" size="lg" />
          </div>
          <h4 className="text-success mb-3">Welcome Back!</h4>
          <p className="text-muted mb-3">{redirectState.message}</p>
          <div className="d-flex justify-content-center align-items-center">
            <Spinner size="sm" className="me-2" />
            <small className="text-muted">Taking you to your dashboard...</small>
          </div>
        </ModalBody>
      </Modal>
    )
  }

  // Redirect to login if not authenticated
  if (authState.isAuthenticated === false) {
    const loginPath = `${process.env.PUBLIC_URL || ""}/auth/login/`
    return <Navigate to={loginPath} replace />
  }

  // Handle authenticated user
  if (authState.isAuthenticated === true) {
    // If user is on root path or login path, show professional redirect
    if (location.pathname === "/" || location.pathname === "/auth/login/" || location.pathname === "/auth/login") {
      
      handleRedirectToDashboard("We're preparing your dashboard experience...")
      return null 
    }
    return (
      <div className="private-route-wrapper">
        <div style={{ display: "none" }}>
          Authenticated: {String(authState.isAuthenticated)} | Path: {location.pathname} | Time:{" "}
          {new Date().toISOString()}
        </div>
        <Outlet />
      </div>
    )
  }

}

export default PrivateRoute
